class CollectionSidebar {
  constructor(root) {
    this.root = root;
    this.toggles = root.querySelectorAll(".sidebar-nav__toggle");
    this.init();
  }

  init() {
    if (!this.toggles.length) return;
    this.toggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => this.handleToggle(event));
    });
  }

  handleToggle(event) {
    const toggle = event.currentTarget;
    const targetId = toggle.getAttribute("aria-controls");
    if (!targetId) return;
    const item = toggle.closest('.sidebar-nav__item');
    const target = item?.querySelector('.sidebar-nav__subcategories');
    if (target?.id !== targetId) return;
    if (!target) return;

    const isExpanded = toggle.getAttribute("aria-expanded") === "true";
    const nextState = (!isExpanded).toString();
    toggle.setAttribute("aria-expanded", nextState);

    const linkedTrigger = this.root.querySelector(
      `.sidebar-nav__link[aria-controls="${targetId}"]`
    );
    if (linkedTrigger) {
      linkedTrigger.setAttribute("aria-expanded", nextState);
    }

    target.classList.toggle("sidebar-nav__subcategories--open", !isExpanded);
  }
}

class CategoryDrawer {
  constructor() {
    this.drawer = document.getElementById("category-drawer");
    this.backdrop = document.querySelector(".category-drawer-backdrop");
    this.triggers = document.querySelectorAll(
      '[aria-controls="category-drawer"]'
    );
    this.closeBtn = this.drawer?.querySelector(".category-drawer__close");
    this.init();
  }

  init() {
    if (!this.drawer) return;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => this.open(trigger));
    });

    this.closeBtn?.addEventListener("click", () => this.close());
    this.backdrop?.addEventListener("click", () => this.close());

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.isOpen()) {
        this.close();
      }
    });
  }

  isOpen() {
    return this.drawer.classList.contains("category-drawer--open");
  }

  open(trigger) {
    this.drawer.classList.add("category-drawer--open");
    this.backdrop?.classList.add("category-drawer-backdrop--visible");
    document.body.style.overflow = "hidden";

    this.triggers.forEach((item) =>
      item.setAttribute("aria-expanded", "true")
    );
    this.closeBtn?.focus();
    this.lastTrigger = trigger;
  }

  close() {
    this.drawer.classList.remove("category-drawer--open");
    this.backdrop?.classList.remove("category-drawer-backdrop--visible");
    document.body.style.overflow = "";

    this.triggers.forEach((item) =>
      item.setAttribute("aria-expanded", "false")
    );
    if (this.lastTrigger) {
      this.lastTrigger.focus();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-collection-sidebar]")
    .forEach((el) => new CollectionSidebar(el));

  new CategoryDrawer();
});
